import {
  APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_BEGIN,
  APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_SUCCESS,
  APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_FAILURE,
  APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { toast } from 'react-toastify';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function toggleProjectJsCdnsFromBuilder(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_BEGIN,
    });
    const { projectId, version, data } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/toggle-js-cdns-builder`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_SUCCESS,
              data: res.data,
            });
            toast.success('Updated Successfully !', {});
            resolve(res.data);
          } else {
            dispatch({
              type: APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissToggleProjectJsCdnsFromBuilderError() {
  return {
    type: APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        toggleProjectJsCdnsFromBuilderPending: true,
        toggleProjectJsCdnsFromBuilderError: null,
      };

    case APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_SUCCESS:
      // The request is success
      return {
        ...state,
        toggleProjectJsCdnsFromBuilderPending: false,
        toggleProjectJsCdnsFromBuilderError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_FAILURE:
      // The request is failed
      return {
        ...state,
        toggleProjectJsCdnsFromBuilderPending: false,
        toggleProjectJsCdnsFromBuilderError: action.data.error,
      };

    case APP_SETTING_TOGGLE_PROJECT_JS_CDNS_FROM_BUILDER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        toggleProjectJsCdnsFromBuilderError: null,
      };

    default:
      return state;
  }
}
